import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ManageSyncPairStageType } from '~/enums/ManageSyncPairStageType';
import { useIntl } from 'react-intl';
import { slices } from '~/redux/slices';
import Box from '~/ui/components/Box/Box';
import Divider from '~/ui/components/Divider/Divider';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import PageLayout from '~/ui/components/PageLayout/PageLayout';
import Text from '~/ui/components/Text/Text';

function Header({ onToggleEnableGuide }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const activeSyncPair = useSelector(
    slices.integrations.selectors.selectActiveSyncPair,
  );
  const manageSyncPairStage = useSelector(
    slices.integrations.selectors.selectManageSyncPairStage,
  );

  const stages = [
    {
      label: intl.formatMessage({
        id: 'Header.provider',
        defaultMessage: 'Provider',
        description: 'Label for provider selection stage',
      }),
      value: ManageSyncPairStageType.Provider,
    },
    {
      label: intl.formatMessage({
        id: 'Header.authentication',
        defaultMessage: 'Authentication',
        description: 'Label for authentication stage',
      }),
      value: ManageSyncPairStageType.Authentication,
    },
    {
      label: intl.formatMessage({
        id: 'Header.foldersAndFileTypes',
        defaultMessage: 'Folders & File types',
        description: 'Label for folders and file types selection stage',
      }),
      value: ManageSyncPairStageType.Folders,
    },
    {
      label: intl.formatMessage({
        id: 'Header.summary',
        defaultMessage: 'Summary',
        description: 'Label for summary stage',
      }),
      value: ManageSyncPairStageType.Summary,
    },
  ];

  const isReauthenticate = !!activeSyncPair?.isReauthenticate;

  const prefix = activeSyncPair ? `${activeSyncPair.name} - ` : '';
  const title = `${prefix}${
    isReauthenticate
      ? intl.formatMessage({
          id: 'Header.reauthenticate',
          defaultMessage: 'Reauthentciate',
          description: 'Title for reauthentication process',
        })
      : intl.formatMessage({
          id: 'Header.newSyncPair',
          defaultMessage: 'New Sync Pair',
          description: 'Title for new sync pair creation',
        })
  }`;

  const handleClose = () => {
    onToggleEnableGuide(true);
    dispatch(slices.integrations.actions.setActiveSyncPair(null));
    dispatch(
      slices.integrations.actions.setManageSyncPairStage(
        ManageSyncPairStageType.None,
      ),
    );
  };

  const centerContent = (
    <FlexLayout alignItems="center" space={3}>
      {stages.map((stage, i) => {
        const isActiveStage = stage.value === manageSyncPairStage;
        return (
          <Fragment key={stage.value}>
            <Text
              color="gray-800"
              disabled={!isActiveStage}
              variant={isActiveStage ? 's-dense-bold' : 's-dense'}
            >
              {stage.label}
            </Text>
            {i < stages.length - 1 && (
              <Box sx={{ width: '24px' }}>
                <Divider />
              </Box>
            )}
          </Fragment>
        );
      })}
    </FlexLayout>
  );

  return (
    <PageLayout.Header
      title={{
        text: title,
      }}
      centerContent={centerContent}
      onClose={handleClose}
    />
  );
}

export default Header;
